module.exports = __webpack_public_path__ + "static/img/con2_imgbg.786b4fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/mainBusiness/con2_imgbg.png
// module id = mOWa
// module chunks = 0